import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FileParameter } from '@api/api';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldConfig, IInputDialogData } from './inputDialogData';

export interface DialogResult {
  inputValues: string[];
  dateValues: Date[];
  dropdownValues: string[];
  fileValues: FileParameter[];
}

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    SmartusComponentsModule,
    TranslateModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
  ],
})
export class InputDialogComponent {
  public constructor(
    public dialogRef: MatDialogRef<InputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IInputDialogData
  ) {}

  onConfirm(): void {
    const result: DialogResult = {
      inputValues: this.data.formFields
        .filter(field => field.type === 'input')
        .map(field => field.value),
      dateValues: this.data.formFields
        .filter(field => field.type === 'date')
        .map(field => field.value),
      dropdownValues: this.data.formFields
        .filter(field => field.type === 'dropdown')
        .map(field => field.value),
      fileValues: this.data.formFields
        .filter(field => field.type === 'file')
        .map(field => field.value),
    } as DialogResult;
    this.close(result);
  }

  onCancel(): void {
    this.close(null);
  }

  onFileSelected(event: Event, field: FormFieldConfig): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    const blob = new Blob([file], { type: file.type });
    field.value = { data: blob, fileName: file.name } as FileParameter;
  }

  getFileName(field: FormFieldConfig): string {
    const value = field.value as FileParameter | undefined;
    return value?.fileName ?? '';
  }

  private close(value: DialogResult | null): void {
    this.dialogRef.close(value);
  }

  public allRequiredFieldsFilled(): boolean {
    return this.data.formFields.every(
      field => !field.required || (field.value && field.value.toLocaleString().trim() !== '')
    );
  }
}
